import { ROUTES } from '../../config/routes'
import { ReactComponent as HomeIcon } from './assets/HomeIcon.svg'
import { ReactComponent as AttendanceIcon } from './assets/AttendanceIcon.svg'
import { ReactComponent as EverythingIcon } from './assets/EverythingIcon.svg'
import { ReactComponent as Sop } from './assets/Sop.svg'
// import { ReactComponent as LeavesIcon } from './assets/LeavesIcon.svg'
import { ReactComponent as OnboardingIcon } from './assets/onboarding.svg'
import { ReactComponent as EmployeeListIcon } from './assets/EmployeeListIcon.svg'

const { HOME, EVERYTHING_JCR, SOPS, ONBOARDING, ATTENDANCE_REPORT, EMPLOYEES_LIST } = ROUTES

export const SIDEBAR_DATA = [
    {
        labelText: 'Home',
        icon: <HomeIcon />,
        route: HOME,
    },
    {
        labelText: 'Attendance Report',
        icon: <AttendanceIcon />,
        route: ATTENDANCE_REPORT,
    },
    // {
    //     labelText: 'Everything JC',
    //     icon: <EverythingIcon />,
    //     route: EVERYTHING_JCR,
    // },
    {
        labelText: 'Teams',// for temporarily sops label text is changing into Teams till we get SOPS new updated design 
        icon: <Sop />,
        route: SOPS,
    },
    {
        labelText: 'Onboarding',
        icon: <OnboardingIcon />,
        route: ONBOARDING,
        onlySuperAdmin: true
    },
    {
        labelText: 'Employee List',
        icon: <EmployeeListIcon />,
        route: EMPLOYEES_LIST,
        onlySuperAdmin: true
    }



]